import React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "./Home/MainLandingScreen";
import Background from "assets/Home/VendorBg.png";
import ManageRepairs from "./Home/ManageRepairs";
import SettingsIcon from "assets/Home/Settings.svg";
import SearchScanIcon from "assets/Home/SearchScan.svg";
import LinkIcon from "assets/Home/Link.svg";
import ClipboardIcon from "assets/Home/ClipdownCheck.svg";
import ServiceProfessionals from "./Home/ServiceProfessionals";
import LicenseInsurance from "assets/Home/LicenseInsurance.svg";
import Location from "assets/Home/Location.svg";
import Review from "assets/Home/Review.svg";
import Award from "assets/Home/Award.svg";
import BuildingIcon from "assets/Home/Building.svg";
import MedalIcon from "assets/Home/Medal.svg";
import CardSignalIcon from "assets/Home/CardSignal.svg";
import ClipdownCheckIcon from "assets/Home/ClipdownCheck.svg";
import BanknoteIcon from "assets/Home/BankNote.svg";
import HowItWorks from "./Home/PropertyWorlFlow";
import HandsOnToFree from "./Home/HandsOnToFree";
import PhoneIcon from "assets/Home/Phone.svg";
import HelpIcon from "assets/Home/HelpCircle.svg";
import ClockRefresh from "assets/Home/ClockRefresh.svg";
import FaceFrown from "assets/Home/FaceFrown.svg";
import Globe from "assets/Home/Globe.svg";
import CheckCircle from "assets/Home/CheckCircle.svg";
import BarChart from "assets/Home/BarChart.svg";
import BankNote from "assets/Home/BankNote.svg";
import PuzzlePiece from "assets/Home/PuzzlePiece.svg";
import LineChartDown from "assets/Home/LineChartDown.svg";
import BellRinging from "assets/Home/BellRinging.svg";
import CalendarIcon from "assets/Home/Calendar.svg";
import LineChartUp from "assets/Home/LineChartUp.svg";
import FrequentlyAskedQuestions from "./Home/FrequentlyAskedQuestions";
import StayUpdated from "./Home/StayUpdated";
import VendorApplyCTA from "./Home/VendorApplyCTA";

const VendorLandingPage = () => {
  const location = useLocation();
  const grayIconStyle = { opacity: 0.55 };

  // Handle hash-based scrolling when page loads
  useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.substring(1); // Remove the # symbol

      // Function to scroll to element with navbar offset
      const scrollToElement = () => {
        const element = document.getElementById(elementId);
        if (element) {
          // Get navbar height to offset the scroll position
          const navbar =
            document.querySelector('[data-testid="navbar"]') ||
            document.querySelector(".MuiAppBar-root") ||
            document.querySelector("header");
          const navbarHeight = navbar ? navbar.offsetHeight : 100; // Default to 100px if navbar not found

          const elementPosition = element.offsetTop - navbarHeight - 20; // Additional 20px padding

          window.scrollTo({
            top: elementPosition,
            behavior: "smooth",
          });
          return true;
        }
        return false;
      };

      // Function to attempt scrolling with multiple strategies
      const attemptScroll = () => {
        // Try immediate scroll
        if (scrollToElement()) return;

        // Try after a short delay
        setTimeout(() => {
          if (scrollToElement()) return;

          // Try after a longer delay
          setTimeout(() => {
            if (scrollToElement()) return;

            // Final attempt with even longer delay
            setTimeout(() => {
              scrollToElement();
            }, 1000);
          }, 500);
        }, 100);
      };

      // Start the scroll attempt process
      attemptScroll();

      // Also set up a MutationObserver to watch for DOM changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            // Check if our target element was added
            const targetElement = document.getElementById(elementId);
            if (targetElement) {
              setTimeout(() => scrollToElement(), 50);
              observer.disconnect();
            }
          }
        });
      });

      // Start observing
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Cleanup observer after 5 seconds
      setTimeout(() => {
        observer.disconnect();
      }, 5000);

      return () => {
        observer.disconnect();
      };
    }
  }, [location.hash, location.pathname]);

  // Additional effect to handle hash changes after page load
  useEffect(() => {
    const handleHashChange = () => {
      if (location.hash) {
        const elementId = location.hash.substring(1);
        const element = document.getElementById(elementId);
        if (element) {
          const navbar =
            document.querySelector('[data-testid="navbar"]') ||
            document.querySelector(".MuiAppBar-root") ||
            document.querySelector("header");
          const navbarHeight = navbar ? navbar.offsetHeight : 100;
          const elementPosition = element.offsetTop - navbarHeight - 20;

          window.scrollTo({
            top: elementPosition,
            behavior: "smooth",
          });
        }
      }
    };

    // Listen for hash changes
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [location.hash]);

  const steps = [
    {
      number: "01",
      basis: "58%",
      title: "Review qualification",
      description:
        "Tell us who you are and how to reach you—basic company info helps us verify your profile",
    },
    {
      number: "02",
      basis: "42%",
      title: "Walk through the platform",
      description:
        "Share your active licenses and proof of insurance so property owners know they’re protected.",
    },
    {
      number: "03",
      basis: "100%",
      title: "Discuss billing rates",
      description:
        "Upload certificates or qualifications that prove your trade expertise and skill level.",
    },

    {
      number: "04",
      basis: "40%",
      title: "Answer questions",
      description:
        "List previous jobs and references so we can showcase your experience and reliability.",
    },
    {
      number: "05",
      basis: "60%",
      title: "Complete onboarding",
      description:
        "Securely add payout and tax information so you can get paid quickly and  stay compliant.",
    },
  ];
  const cards = [
    {
      icon: SettingsIcon,
      title: "Get Pre Qualified Jobs Sent to You",
      description:
        "We match you with real jobs based on your trade, location, and availability.",
    },
    {
      icon: ClipboardIcon,
      title: "Work Without the Admin Headache",
      description:
        "We handle client communication, scheduling, and invoicing so you can focus on what you do best.",
    },
    {
      icon: LinkIcon,
      title: "Manage Your Jobs in One Place",
      description:
        "View job details, upload photos, and track payments all from your Properteasy dashboard. No paperwork. No confusion. Just a clean, organized workflow.",
    },
  ];
  const renderSection = {
    leftSection: [
      {
        icon: PhoneIcon,
        text: "Chasing leads and endless estimates",
      },
      {
        text: "Inconsistent work",
        icon: PuzzlePiece,
      },
      {
        icon: LineChartDown,
        text: "High cost advertising with no guaranteed return ",
      },
      {
        icon: FaceFrown,
        text: "Complex invoicing and time-consuming bookkeeping",
      },
    ],
    rightSection: [
      {
        icon: BellRinging,
        text: "We broadcast work ready to be scheduled",
      },
      {
        icon: CalendarIcon,
        text: "No more holes in your schedule. Work as much or as little as you want",
      },
      {
        icon: LineChartUp,
        text: "Pipeline of work with zero ad spend",
      },
      {
        icon: BarChart,
        text: "Zero client invoicing. Zero bookkeeping",
      },
    ],
  };
  const cardsProfessionals = [
    {
      icon: BuildingIcon,
      title: "Business Details",
    },
    {
      icon: CardSignalIcon,
      title: "License & Insurance Information",
    },
    {
      icon: MedalIcon,
      title: "Trade Certificate",
    },
    {
      icon: ClipdownCheckIcon,
      title: "Reference & Work History",
    },
    {
      icon: BanknoteIcon,
      title: "Payment & Tax Details",
    },
  ];

  const processBullets = [
    "Review qualifications",
    "Walk through the platform",
    "Discuss billing rates",
    "Answer questions",
    "Complete onboarding",
  ];

  return (
    <div
      style={{ marginTop: "96px" }}
      className="flex flex-col justify-center items-center "
    >
      <HeroSection
        background={Background}
        title="Finding Work Shouldn't be Harder Than Doing it"
        description="Let us handle the calls, the screening, and the payments. You handle the job."
        buttonText="Get Started as a Vendor"
        buttonLink="/signup?account_type=VENDOR"
      />
      <ManageRepairs
        id="grow-your-business"
        classFlex="flex gap-8 md:flex-row flex-col  "
        chipTxt="Grow Your Business"
        iconStyle={grayIconStyle}
        cards={cards}
        title="Ready to Work Jobs That Fit Your Schedule"
        description="Properteasy connects you with real, paying customers so you can focus on your craft. Choose your work, and when you do it, without the hassle. Our all in one platform provides you with clear job details, ongoing opportunities, and timely payments. Properteasy is a no cost business development solution where everyone wins. "
      />
      <ServiceProfessionals
        id="verified-vendor-onboarding"
        cards={cardsProfessionals}
        iconStyle={grayIconStyle}
        chipText="Verified Vendor Onboarding"
        title="Become a Trusted Properteasy Vendor"
        description="To join our network and start receiving job requests, vendors go through a straightforward onboarding process designed to ensure quality and reliability for property owners."
      >
        <div className="flex flex-col  text-[#595959] font-medium ">
          <h1 className="font-medium text-[32px] text-[#000] mb-4">
            The Process
          </h1>
          <h2 className="mb-6 text-[#000]" style={{ letterSpacing: "0.03em" }}>
            After submitting your information through our secure portal, the
            Properteasy team will review your credentials and all supporting
            documentation.
          </h2>
          <h2 className="mb-4 text-[#000]">
            Next, you will be contacted by one of our team members in order to:
          </h2>
          <ul className="list-disc list-inside space-y-2 pl-[18px]">
            {processBullets.map((bullet, index) => (
              <li
                key={index}
                className="text-[#3CAB5C] md:text-[24px] text-[18px] font-medium"
              >
                <span className="text-[#000]"> {bullet}</span>
              </li>
            ))}
          </ul>
          <h2 className="mt-6 text-[#000]">
            Once onboarded, you'll have access to an endless broadcast of job
            requests tailored to your trade and location.
          </h2>
        </div>
      </ServiceProfessionals>
      {/* <HowItWorks steps={steps} /> */}
      <div className="lg:max-w-[1440px] w-full mx-auto md:py-[64px] py-8">
        {" "}
        <div className="flex flex-col gap-3 md:gap-4 md:px-12 px-5  lg:gap-6  w-full mx-auto">
          <h5
            id="payout-stucture-vendor"
            className="bg-[#3CAB5C1A] text-[#3CAB5C] px-3 py-1 rounded-full  border border-[#3CAB5C] font-medium w-fit"
          >
            Payout Stucture
          </h5>
          <div className="flex md:flex-row flex-col gap-3">
            {" "}
            <h1 className=" font-medium w-full text-[#242424] text-[24px] md:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0]">
              Develop Your Business And Get Paid Fairly
            </h1>
            <h2 className=" text-[#242424] w-full ">
              Properteasy manages all billing and payments directly with
              property owners, so you don't have to. We simultaneously provide
              you with a steady stream of reliable job opportunities, while
              eradicating administrative burdens. In order to provide these
              valuable benefits to our vendors, Properteasy retains a negotiated
              percentage of the total job cost.
            </h2>
          </div>
        </div>
      </div>
      <VendorApplyCTA id="apply-now-vendor" buttonLink="/signup?account_type=VENDOR" />
      <HandsOnToFree buttonLink="/signup?account_type=VENDOR"
        id="what-makes-properteasy-different-vendor"
        title="The Hustle is Over"
        subTitleone="The Old Way"
        subTitleTwo="With Properteasy"
        leftSection={renderSection.leftSection}
        rightSection={renderSection.rightSection}
      />
      <FrequentlyAskedQuestions id="faqs-vendor" />
      <StayUpdated id="stay-updated-vendor" />
    </div>
  );
};

export default VendorLandingPage;
